module.exports = "https://static.wmbcdn.com/uniweb/images/a10808c4ba5761b1689bceca152b466e.svg";